import { ChangeEvent, FC, useCallback } from 'react';

import Column from 'bloko/blocks/column';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import { ActProcessingType, setProcessingType } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const SelectProcessingType: FC = () => {
    const processingType = useSelector((state) => state.acts.processingType);

    const dispatch = useDispatch();

    const trl = useTrls();

    const ITEMS = {
        [ActProcessingType.All]: trl('admin.actsReport.processingType.all'),
        [ActProcessingType.Manual]: trl('admin.actsReport.processingType.manual'),
        [ActProcessingType.Auto]: trl('admin.actsReport.processingType.auto'),
    };

    const onChange = useCallback(
        (event: ChangeEvent<HTMLSelectElement>) => {
            const value = event.target.value as ActProcessingType;
            dispatch(setProcessingType(value));
        },
        [dispatch]
    );

    return (
        <FormSpacer>
            <Column xs="2" s="2" m="2" l="2" container>
                <Select value={processingType} onChange={onChange}>
                    {Object.entries(ITEMS).map(([key, value]) => (
                        <Option key={key} value={key}>
                            {value}
                        </Option>
                    ))}
                </Select>
            </Column>
        </FormSpacer>
    );
};

export default SelectProcessingType;
